import React, { useState, useEffect } from "react";
import { signInWithPopup } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { auth, db, googleProvider } from "./firebase";
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const LoginPage = () => {
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [deviceId, setDeviceId] = useState(null);
    const [ip, setIp] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const init = async () => {
            try {
                const fp = await FingerprintJS.load();
                const result = await fp.get();
                setDeviceId(result.visitorId);
            } catch (error) { console.error("FP Error:", error); }

            try {
                const res = await fetch("https://api.ipify.org?format=json");
                const data = await res.json();
                setIp(data.ip);
            } catch (e) { console.error("IP Error", e); }
        };
        init();
    }, []);

    const handleGoogleSignIn = async () => {
        setError("");
        setLoading(true);

        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;

            const userDocRef = doc(db, "users", user.uid);
            const userDocSnap = await getDoc(userDocRef);

            if (!userDocSnap.exists()) {
                await setDoc(userDocRef, {
                    email: user.email,
                    name: user.displayName,
                    displayName: user.displayName,
                    deviceId: deviceId || "unknown",
                    ip: ip || "unknown",
                    verified: true,
                    walletBalance: 1000,
                    lastLoginAt: new Date().toISOString(),
                    createdAt: new Date().toISOString()
                });
            } else {
                await setDoc(userDocRef, {
                    deviceId: deviceId || "unknown",
                    ip: ip || "unknown",
                    lastLoginAt: new Date().toISOString()
                }, { merge: true });
            }

            navigate("/");
        } catch (err) {
            console.error("Google Sign-In Error:", err);
            setError("Failed to sign in with Google. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <div className="spinner"></div>
        </div>
    );

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '20px' }}>
            <div className="glass-container" style={{ maxWidth: '400px', width: '100%', padding: '40px', textAlign: 'center' }}>
                <h1 style={{ fontSize: '2rem', marginBottom: '1.5rem' }}>
                    Welcome to Nottsify
                </h1>
                
                <p style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>
                    Sign in to continue generating amazing notes.
                </p>

                {error && (
                    <div style={{ background: 'rgba(255,107,107,0.15)', border: '1px solid #ff6b6b', padding: '15px', borderRadius: '8px', marginBottom: '20px', color: '#ff6b6b' }}>
                        {error}
                    </div>
                )}

                <button 
                    onClick={handleGoogleSignIn} 
                    className="btn-primary" 
                    style={{ 
                        width: '100%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        gap: '10px',
                        background: 'white',
                        color: '#333',
                        border: '1px solid #ddd'
                    }}
                >
                    <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" style={{ width: '24px', height: '24px' }} />
                    Sign in with Google
                </button>
            </div>
        </div>
    );
};

export default LoginPage;
